'use client';

import { c as _c } from "react/compiler-runtime";
import DefaultAlertDialog from '@/components/DefaultAlertDialog';
import { useTranslations } from 'next-intl';
type DeleteCommentConfirmModalProps = {
  open?: boolean;
  onCancel?: () => void;
  onAction?: () => void;
  container?: HTMLElement | null;
};
export default function DeleteCommentConfirmModal(t0) {
  const $ = _c(19);
  const {
    open: t1,
    onCancel,
    onAction,
    container
  } = t0;
  const open = t1 === undefined ? false : t1;
  const t = useTranslations();
  let t2;
  if ($[0] !== t) {
    t2 = t("delete-comment-confirm-modal.title");
    $[0] = t;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t) {
    t3 = t("delete-comment-confirm-modal.description");
    $[2] = t;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <p className="body1-omni-styles text-vive-primary-20">{t3}</p>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t) {
    t5 = t("delete-comment-confirm-modal.cancel");
    $[6] = t;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t) {
    t6 = t("delete-comment-confirm-modal.action");
    $[8] = t;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== container || $[11] !== onAction || $[12] !== onCancel || $[13] !== open || $[14] !== t2 || $[15] !== t4 || $[16] !== t5 || $[17] !== t6) {
    t7 = <DefaultAlertDialog open={open} type="custom" title={t2} container={container} content={t4} cancelText={t5} actionText={t6} onCancel={onCancel} onAction={onAction} cancelButtonClassName="rounded-full px-5 py-3 border-[1.5px] border-vive-primary-20 text-vive-primary-20 buttonM-omni-styles hover:border-vive-primary-40 hover:text-vive-primary-40 active:text-vive-primary-60 active:border-vive-primary-60" actionButtonClassName="rounded-full px-5 py-3 text-white buttonM-omni-styles bg-[#f53232] hover:bg-[#d42a2a] active:bg-[#b32424] " allowOutsideInteraction={true} />;
    $[10] = container;
    $[11] = onAction;
    $[12] = onCancel;
    $[13] = open;
    $[14] = t2;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
}